// import { Component, OnInit } from '@angular/core';
// import { homeConst } from '../../constants';

// @Component({
//     selector: 'app-navbar',
//     templateUrl: './navbar.component.html',
//     styleUrls: ['./navbar.component.scss'],
// })
// export class NavbarComponent implements OnInit {
//     formValues = homeConst;

//     constructor() {}

//     ngOnInit(): void {}

//     scrollDown() {
//         window.scrollTo(0, document.body.scrollHeight);
//     }
// }


import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { homeConst } from '../../constants';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {

    formValues = homeConst;

    mobileMenuOpen = false;

    constructor(
        private router: Router
    ) { }

    ngOnInit(): void { }

    toggleMobileMenu(): void {
        this.mobileMenuOpen = !this.mobileMenuOpen;
    }

    closeMobileMenu(): void {
        this.mobileMenuOpen = false;
    }

    goHome(): void {
        this.closeMobileMenu();

        if (this.router.url === '/' || this.router.url === '') {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

            return;
        }

        this.router.navigate(['/']).then(() => {
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }, 100);
        });
    }

    scrollToSection(sectionId: string): void {

        this.closeMobileMenu();

        const isHome =
            this.router.url === '/' ||
            this.router.url === '';

        if (isHome) {

            this.scrollToElement(sectionId);

            return;
        }

        this.router.navigate(['/']).then(() => {

            setTimeout(() => {
                this.scrollToElement(sectionId);
            }, 150);

        });
    }

    mobileSectionClick(sectionId: string): void {
        this.scrollToSection(sectionId);
    }

    private scrollToElement(sectionId: string): void {

        const element =
            document.getElementById(sectionId);

        if (!element) {
            console.warn(
                `Section #${sectionId} was not found on the home page.`
            );

            return;
        }

        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}